import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";

import Breadcrumbs from "components/Breadcrumbs/Breadcrumbs";

import AppStore from "AppStore";

import "./ConditionalBreadcrumbs.scss";

const INTRO_WITH_POINTS_PAGES = [
  "/prodvizhenie-trekov-yandexmusic",
  "/prodvizhenie-trekov-yandexmusic-presave",
  "/prodvizhenie-trekov-yandexmusic-proslushka",
  "/prodvizhenie-trekov-vkmusic",
  "/prodvizhenie-trekov-vkmusic-presave",
  "/prodvizhenie-trekov-vkmusic-proslushka",
  "/promotion-on-spotify",
  "/promotion-on-applemusic",
];

export const isIntroWithPointsPage = (pathname) => {
  return INTRO_WITH_POINTS_PAGES.some((path) => pathname.startsWith(path));
};

const ConditionalBreadcrumbs = observer(() => {
  const location = useLocation();

  if (!AppStore.isAuth && isIntroWithPointsPage(location.pathname)) {
    return null;
  }

  return <Breadcrumbs />;
});

export default ConditionalBreadcrumbs;
